// postMessage contract between the Portal and the live dashboards app (pmp-web-dashboard-new, embed mode).
// Keep in sync with src/services/live/embedBridge.js in that repository.

export const LIVE_MESSAGE = {
  ready: 'pmp-live:ready',
  token: 'pmp-live:token',
  tokenRequest: 'pmp-live:token-request',
  status: 'pmp-live:status',
} as const

/** iframe → Portal */
export type LiveEmbedInboundMessage =
  | { type: typeof LIVE_MESSAGE.ready }
  | { type: typeof LIVE_MESSAGE.tokenRequest }
  | { type: typeof LIVE_MESSAGE.status; online: boolean; since: number | null }

/** Portal → iframe */
export interface LiveEmbedTokenMessage {
  type: typeof LIVE_MESSAGE.token
  token: string
  /** ms since epoch */
  expiresOn: number
}

export type LiveEmbedStatus = 'loading' | 'online' | 'offline' | 'unavailable'

export interface LiveEmbedState {
  status: LiveEmbedStatus
  /** Time of the last data received (ms since epoch) when offline, else null. */
  since: number | null
}

export function isLiveEmbedInboundMessage(data: unknown): data is LiveEmbedInboundMessage {
  if (!data || typeof data !== 'object') return false
  const type = (data as { type?: unknown }).type
  if (type === LIVE_MESSAGE.ready || type === LIVE_MESSAGE.tokenRequest) return true
  if (type !== LIVE_MESSAGE.status) return false
  const { online, since } = data as { online?: unknown; since?: unknown }
  return typeof online === 'boolean' && (since === null || typeof since === 'number')
}
